"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.INFO_LIST_COLOR = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _gerenciatdUnifiedicons = _interopRequireDefault(require("@bit/gerenciatd.unifiedicons.svg-icon-label"));

var _gerenciatdUtils = require("@bit/gerenciatd.utils.common");

require("./infoList.scss");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var INFO_LIST_COLOR = {
  BLACK: 'black',
  WHITE: 'white',
  GREEN: 'green',
  GREEN_LIGHT: 'green-light',
  GREEN_DARK: 'green-dark',
  COOL_GREY: 'cool-grey',
  GREY_6: 'grey6',
  GREY_5: 'grey5',
  GREY_5B: 'grey5b',
  GREY_4: 'grey4',
  GREY_4A: 'grey4a',
  GREY_3: 'grey3',
  GREY_2: 'grey2',
  GREY_1: 'grey1',
  GREY_1A: 'grey1a',
  GREY_A: 'greya',
  GREY_0: 'grey0',
  ORANGE: 'orange',
  ORANGE_LIGHT: 'orange-light',
  ORANGE_DARK: 'orange-dark',
  BLUE: 'blue',
  BLUE_A: 'blue-a',
  PURPLE: 'purple',
  PURPLE_LIGHT: 'purple-light',
  PURPLE_DARK: 'purple-dark',
  PINK: 'pink',
  PINK_LIGHT: 'pink-light',
  PINK_DARK: 'pink-dark',
  PIPPER: 'pipper',
  PIPPER_LIGHT: 'pipper-light',
  PIPPER_DARK: 'pipper-dark'
};
/**
* Stateless component to draw an image
* @param {string} items array of items like: {svgId, label, labelPosition}
* @param {string} multiline flexx-wrap (Flex) allow content drop to a second line
* @param {string} direction row | column (flex)
* @param {string} space betwwen or evenly (Flex)
* @param {string} color color for this svg
* @returns {JSX} Component image JSX.
*/

exports.INFO_LIST_COLOR = INFO_LIST_COLOR;

var InfoList = function InfoList(props) {
  var myProps = (0, _gerenciatdUtils.setUpPropsByDevice)(props);
  var className = myProps.className,
      kind = myProps.kind,
      items = myProps.items,
      separator = myProps.separator,
      multiline = myProps.multiline,
      direction = myProps.direction,
      space = myProps.space,
      color = myProps.color,
      everyChildSameWidth = myProps.everyChildSameWidth,
      SvgIconLoader = myProps.SvgIconLoader;
  var myClassName = className ? " ".concat(className) : '';
  var multilineCss = multiline ? ' infoList--multiline' : ' infoList--singleline';
  var separatorCss = " infoList_".concat(kind, "_separator--").concat(separator);
  var directionCss = direction === 'row' ? ' infoList--row' : ' infoList--column';
  var spaceCss = ' infoList--spacebetween';

  switch (space) {
    case 'center':
      spaceCss = ' infoList--spacecenter';
      break;

    case 'between':
      spaceCss = ' infoList--spacebetween';
      break;

    case 'left':
      spaceCss = ' infoList--spaceleft';
      break;

    case 'right':
      spaceCss = ' infoList--spaceright';
      break;

    default:
      spaceCss = ' infoList--spaceevenly';
      break;
  }

  var colorCss = " infoList--".concat(color);
  var key = "".concat(JSON.stringify(items));
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "infoList ".concat(kind).concat(multilineCss).concat(directionCss).concat(spaceCss).concat(colorCss).concat(separatorCss).concat(myClassName),
    children: items.map(function (item, index) {
      var itemStyle = everyChildSameWidth ? {
        maxWidth: "".concat(98 / items.length, "%")
      } : {};
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "infoList_item",
        style: itemStyle,
        children: /*#__PURE__*/(0, _react.createElement)(_gerenciatdUnifiedicons["default"], _objectSpread(_objectSpread({}, item), {}, {
          id: item.svgId,
          key: "svgIconLabel-".concat(key, "-").concat(index.toString()),
          SvgIconLoader: SvgIconLoader
        }))
      }, "InfoList_item_".concat(item.item ? item.svgId : '', "-").concat(index.toString()));
    })
  });
};

InfoList.propTypes = {
  SvgIconLoader: _propTypes["default"].func.isRequired,
  className: _propTypes["default"].string,
  kind: _propTypes["default"].oneOf(['grid2c', 'flex']),

  /**
   * {
   *  "info": "Define el array con la información de los items que forman el listado",
   *  "kind": "both",
   *  "beautifulName": "Elementos"
   * }
   */
  items: _propTypes["default"].array.isRequired,

  /**
   * {
   *  "info": "Establece el separador entre los elementos que forman el listado",
   *  "kind": "both",
   *  "beautifulName": "Separador"
   * }
   */
  separator: _propTypes["default"].oneOf(['none', 'white']),

  /**
   * {
   *  "info": "Establece si los elementos del listados son o no multilinea",
   *  "kind": "both",
   *  "beautifulName": "Multilinea"
   * }
   */
  multiline: _propTypes["default"].bool,

  /**
   * {
   *  "info": "Establece la dirección de los elementos del listado para que se comporten como filas o columna",
   *  "kind": "both",
   *  "beautifulName": "Dirección"
   * }
   */
  direction: _propTypes["default"].oneOf(['row', 'column']),

  /**
   * {
   *  "info": "Define donde se alinea el elemento: izquierda, derecha, centrado,...",
   *  "kind": "both",
   *  "beautifulName": "Espacio"
   * }
   */
  space: _propTypes["default"].oneOf(['left', 'right', 'between', 'evenly', 'center']),

  /**
   * {
   *  "info": "Establece el color para el SVG en caso de tenerlo",
   *  "kind": "both",
   *  "beautifulName": "Color SVG"
   * }
   */
  color: _propTypes["default"].oneOf([INFO_LIST_COLOR.BLACK, INFO_LIST_COLOR.WHITE, INFO_LIST_COLOR.GREEN, INFO_LIST_COLOR.GREEN_LIGHT, INFO_LIST_COLOR.GREEN_DARK, INFO_LIST_COLOR.COOL_GREY, INFO_LIST_COLOR.GREY_6, INFO_LIST_COLOR.GREY_5, INFO_LIST_COLOR.GREY_5B, INFO_LIST_COLOR.GREY_4, INFO_LIST_COLOR.GREY_4A, INFO_LIST_COLOR.GREY_3, INFO_LIST_COLOR.GREY_2, INFO_LIST_COLOR.GREY_1, INFO_LIST_COLOR.GREY_1A, INFO_LIST_COLOR.GREY_A, INFO_LIST_COLOR.GREY_0, INFO_LIST_COLOR.ORANGE, INFO_LIST_COLOR.ORANGE_LIGHT, INFO_LIST_COLOR.ORANGE_DARK, INFO_LIST_COLOR.BLUE, INFO_LIST_COLOR.BLUE_A, INFO_LIST_COLOR.PURPLE, INFO_LIST_COLOR.PURPLE_LIGHT, INFO_LIST_COLOR.PURPLE_DARK, INFO_LIST_COLOR.PINK, INFO_LIST_COLOR.PINK_LIGHT, INFO_LIST_COLOR.PINK_DARK, INFO_LIST_COLOR.PIPPER, INFO_LIST_COLOR.PIPPER_LIGHT, INFO_LIST_COLOR.PIPPER_DARK]),

  /**
   * {
   *  "info": "Establece si todos los items del listado tienen el mismo tamaño o no",
   *  "kind": "both",
   *  "beautifulName": "Items iguales"
   * }
   */
  everyChildSameWidth: _propTypes["default"].bool
};
InfoList.defaultProps = {
  className: '',
  kind: 'flex',
  separator: 'none',
  multiline: true,
  direction: 'row',
  space: 'between',
  color: INFO_LIST_COLOR.BLACK,
  everyChildSameWidth: false
};
var _default = InfoList;
exports["default"] = _default;

//# sourceMappingURL=index.js.map